import { useEffect } from "react";
import { useLocation, useRouteLoaderData } from "react-router";
import * as fbq from "~/modules/analytics/fbq";
import type { loader } from "~/root";

export function MetaScripts() {
  const data = useRouteLoaderData<typeof loader>("root");
  const location = useLocation();

  useEffect(() => {
    if (data?.metaPixel && !!window.fbq) {
      fbq.pageview();
    }
  }, [location]);

  useEffect(() => {
    if (data?.metaPixel.id) {
      const scriptHtml = `!function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
}(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${data.metaPixel.id}');
fbq('track', 'PageView');`;

      const script = window.document.createElement("script");
      script.innerHTML = scriptHtml;
      window.document.head.appendChild(script);
    }
  }, []);

  return (
    !!data?.metaPixel.id && (
      <noscript>
        <img
          height="1"
          width="1"
          src={`https://www.facebook.com/tr?id=${data.metaPixel.id}&ev=PageView&noscript=1`}
          alt=""
          className="hidden invisible"
        />
      </noscript>
    )
  );
}
